var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0883789,
    width: 39,
    height: 36.6431,
    fill: "url(#pattern0_452_1791)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_452_1791",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_452_1791",
    transform: "matrix(0.01 0 0 0.0106432 0 -0.0321601)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_452_1791",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAmNJREFUeAHt3U1OwlAYRuFuy4kjE1bgMvpdwj7YCGtxMybONcWWELD2tvdQCj0mjUbbV30O/hCNVpUPCiiggAIKKKCAAgoooIACowW22+1Lc4y+0At4gSZERHzWdf2VUnrlX4OL2QJdjIj4bg6jZNPxJ17GMApvnL3YF8Mo2YTciUMxjMJZDy7lxjDKIGX5CWNjGKXcvHdhagyj9JJOf0FpDKNMt7+6kophlCva8c+gYxhlfIPTFbeKYZQTcf4Tt45hlPwW1VwxjJIRZe4YRvknyr1iGOWPKPeOYZSzKEuJYZSqmv0LeIc+9HiVP+Ra2kfGZaRVRVl6jC7OKqI8SoxVRHm0GE8d5VFjPG2UlNImpfQ+9YiIfYdT8Hg/9fW3123OvmNf95MNSEGI4+9sNRvrVgTfe4OAmMSUQQhFcMMgICYxZRBCEdwwCIhJTBmEUAQ3DAJiElMGIRTBDYOAmMSUQQhFcMMgICYxZRBCEdwwCIhJTBmEUAQ3DAJiElMGIRTBDYOAmMSUQQhFcMMgICYxZRBCEdwwCIhJTBmEUAQ3DAJiElMGIRTBDYOAmMSUQQhFcMMgICYxZRBCEdwwCIhJTBmEUAQ3DAJiElMGIRTBDYOAmMSUQQhFcMMgICYxVdf1W0R8lBzNBvG2uKGAAgoooIACCiiggAIKKKCAAgoooIACmQIRsYuIgwdisMtk7z+tDXH8q2ylf9XN6+PQL535EoP8/ltX6MZkEAiS+gxhEIO0/7l5YRDULbx0x4+Qhd0wDPKMQbwfwt0PK78fkvndsacpoIACCiiggAIKKKCAArkCP4wWQ2d6rAH6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a17b39a40fc1e573b609ca00f7464ed9.svg";
export { ForwardRef as ReactComponent };